// For Noticfaction
export async function createNoticAPI(data) {
    const response = await fetch("https://msdskserver.onrender.com/api/notifaction", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": "Bearer " + sessionStorage.getItem("token")
        },
        body: JSON.stringify(data)
    });
    return await response.json();
}


export async function getNoticAPI() {
    var response = await fetch("https://msdskserver.onrender.com/api/notifaction/", {
        method: "get",
        headers: {
            "Content-Type": "application/json",
            "Authorization": "Bearer " + sessionStorage.getItem("token")
        }
    })
    return await response.json()
}

export async function updateNoticAPI(data) {
    var response = await fetch("https://msdskserver.onrender.com/api/notifaction/" + data._id, {
        method: "put",
        headers: {
            "Content-Type": "application/json",
            "Authorization": "Bearer " + sessionStorage.getItem("token")
        },
        body: JSON.stringify(data)
    })
    return await response.json()
}

export async function deleteNoticAPI(data) {
    var response = await fetch("https://msdskserver.onrender.com/api/notifaction/" + data._id, {
        method: "delete",
        headers: {
            "Content-Type": "application/json",
            "Authorization": "Bearer " + sessionStorage.getItem("token")
        }
    })
    return await response.json()
}

// For Contact
export async function createContactAPI(data) {
    const response = await fetch("https://msdskserver.onrender.com/api/contact/", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": "Bearer " + sessionStorage.getItem("token")
        },
        body: JSON.stringify(data)
    });
    return await response.json();
}

export async function getContactAPI() {
    var response = await fetch("https://msdskserver.onrender.com/api/contact/", {
        method: "get",
        headers: {
            "Content-Type": "application/json",
            "Authorization": "Bearer " + sessionStorage.getItem("token")
        }
    })
    return await response.json()
}

export async function updateContactAPI(data) {
    var response = await fetch("https://msdskserver.onrender.com/api/contact/" + data._id, {
        method: "put",
        headers: {
            "Content-Type": "application/json",
            "Authorization": "Bearer " + sessionStorage.getItem("token")
        },
        body: JSON.stringify(data)
    })
    return await response.json()
}

export async function deleteContactAPI(data) {
    var response = await fetch("https://msdskserver.onrender.com/api/contact/" + data._id, {
        method: "delete",
        headers: {
            "Content-Type": "application/json",
            "Authorization": "Bearer " + sessionStorage.getItem("token")
        }
    })
    return await response.json()
}

// For Category
export async function createCategoryAPI(data) {
    const response = await fetch("https://msdskserver.onrender.com/api/category/", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": "Bearer " + sessionStorage.getItem("token")
        },
        body: JSON.stringify(data)
    });
    return await response.json();
}

export async function getCategoryAPI() {
    var response = await fetch("https://msdskserver.onrender.com/api/category/", {
        method: "get",
        headers: {
            "Content-Type": "application/json",
            "Authorization": "Bearer " + sessionStorage.getItem("token")
        }
    })
    return await response.json()
}

export async function updateCategoryAPI(data) {
    var response = await fetch("https://msdskserver.onrender.com/api/category/" + data._id, {
        method: "put",
        headers: {
            "Content-Type": "application/json",
            "Authorization": "Bearer " + sessionStorage.getItem("token")
        },
        body: JSON.stringify(data)
    })
    return await response.json()
}

export async function deleteCategoryAPI(data) {
    var response = await fetch("https://msdskserver.onrender.com/api/category/" + data._id, {
        method: "delete",
        headers: {
            "Content-Type": "application/json",
            "Authorization": "Bearer " + sessionStorage.getItem("token")
        }
    })
    return await response.json()
}

// For User
export async function createUserAPI(data) {
    const response = await fetch("https://msdskserver.onrender.com/api/user/", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": "Bearer " + sessionStorage.getItem("token")
        },
        body: JSON.stringify(data)
    });
    return await response.json();
}

export async function getUserAPI() {
    var response = await fetch("https://msdskserver.onrender.com/api/user/", {
        method: "get",
        headers: {
            "Content-Type": "application/json",
            "Authorization": "Bearer " + sessionStorage.getItem("token")
        }
    })
    return await response.json()
}

export async function updateUserAPI(data) {
    var response = await fetch("https://msdskserver.onrender.com/api/user/" + data._id, {
        method: "put",
        headers: {
            "Content-Type": "application/json",
            "Authorization": "Bearer " + sessionStorage.getItem("token")
        },
        body: JSON.stringify(data)
    })
    return await response.json()
}

export async function deleteUserAPI(data) {
    var response = await fetch("https://msdskserver.onrender.com/api/user/" + data._id, {
        method: "delete",
        headers: {
            "Content-Type": "application/json",
            "Authorization": "Bearer " + sessionStorage.getItem("token")
        }
    })
    return await response.json()
}

// For NewsLatter
export async function createNewsletterAPI(data) {
    const response = await fetch("https://msdskserver.onrender.com/api/user/", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(data)
    });
    return await response.json();
}

export async function getNewsletterAPI() {
    var response = await fetch("https://msdskserver.onrender.com/api/user/", {
        method: "get",
        headers: {
            "Content-Type": "application/json",
            "Authorization": "Bearer " + sessionStorage.getItem("token")
        }
    })
    return await response.json()
}

export async function deleteNewsletterAPI(data) {
    var response = await fetch("https://msdskserver.onrender.com/api/user/" + data._id, {
        method: "delete",
        headers: {
            "Content-Type": "application/json",
            "Authorization": "Bearer " + sessionStorage.getItem("token")
        }
    })
    return await response.json()
}